export const commentData = {
	data() {
		return {
			headerList: [
				{
					prop: 'date',
					label: '时间',
					width: 200,
					tooltip: true
				},
				{
					prop: 'show_title',
					label: '视频标题',
					width: 250
				},
				{
					prop: 'flow',
					label: '流量消耗(GB)',
					width: 150,
					tooltip: true
				},
				{
					prop: 'product_title',
					label: '来源课程',
					width: 200
				},
				{
					prop: 'order_no',
					label: '来源订单',
					width: 300
				},
			],
			RechargeLog:[//购买记录
				{
					prop: 'storage',
					label: '新增空间',
					width: 200,
					tooltip: true
				},
				{
					prop: 'created_time',
					label: '升级时间',
					width: 250
				},
				{
					prop: 'expire_time',
					label: '到期时间',
					width: 150,
					tooltip: true
				},
				{
					prop: 'variable_hours',
					label: '有效时长（天）',
					width: 200
				},
				{
					prop: 'pay_amount',
					label: '付费金额（元）',
					width: 300
				},
			],
		}
	}
}